<template>
    <div>
        <DisclosureButton
            class="rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            @click="onClick"
        >
            <slot v-if="!open">
                <MenuIcon class="block h-6 w-6" aria-hidden="true"/>
            </slot>
            <slot v-else>
                <XIcon class="block h-6 w-6" aria-hidden="true"/>
            </slot>
        </DisclosureButton>
    </div>
</template>

<script setup>
import {DisclosureButton} from "@headlessui/vue";
import {MenuIcon, XIcon} from "@heroicons/vue/outline";
import {defineProps, defineEmits} from "vue";

defineProps({
    open: Boolean,
});

const emit = defineEmits(['click']);

const onClick = () => {
    emit('click');
}
</script>
